import { createSlice } from "@reduxjs/toolkit";
import { FetchInventoryList } from "./inventoryAction";

interface InventoryState {
  inventory: any | null;
  loading: boolean;
  error: string | null;
  totalRecord: number;
  openInventoryModal: boolean;
  modalData: any;
  editInventoryModalOpen?: boolean;
  editInventoryData?: any;
}

const initialState: InventoryState = {
  inventory: [],
  loading: false,
  error: null,
  totalRecord: 0,
  openInventoryModal: false,
  modalData: { data: [], headers: [] },
  editInventoryModalOpen: false,
  editInventoryData: null,
};

const inventorySlice = createSlice({
  name: 'inventory',
  initialState,
  reducers: {
    setOpenInventoryModal: (state, { payload }) => {
      state.openInventoryModal = true;
      state.modalData = payload;
    },
    setCloseInventoryModal: (state) => {
      state.openInventoryModal = false;
      state.modalData = { data: [], headers: [] };
    },
    setOpenEditInventoryModal: (state, { payload }) => {
      state.editInventoryModalOpen = true;
      state.editInventoryData = payload;
    },
    setCloseEditInventoryModal: (state) => {
      state.editInventoryModalOpen = false;
      state.editInventoryData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(FetchInventoryList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(FetchInventoryList.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.inventory = payload.data; // Store full inventory details
        state.totalRecord = payload?.totalRecord || 0;
      })
      .addCase(FetchInventoryList.rejected, (state, { payload }) => {
        state.loading = false;
        state.error =
          (payload as { responseMessage?: string })?.responseMessage || "Failed to fetch inventory status";
      });
  },
});

export const { setOpenInventoryModal, setCloseInventoryModal, setOpenEditInventoryModal, setCloseEditInventoryModal } = inventorySlice.actions;

export const inventoryReducer = inventorySlice.reducer;
